import { StyledCell, StyledHeaderRow } from "../table.styles";
import { useTheme } from "@mui/material";
import { Table, flexRender } from "@tanstack/react-table";
import { SortButton } from "./SortButton";
import { Theme } from "../../Theme";
import { DefaultRow } from "../types";
import ColumnFilterButton from "./ColumnFilter/ColumnFilterButton";

type Props<TRow> = {
  table: Table<TRow>;
  columnsSize: number[];
};

export const TableHeader = <TRow extends DefaultRow>({
  table,
  columnsSize,
}: Props<TRow>) => {
  const theme = useTheme<Theme>();
  const headerColumns = table.getHeaderGroups();
  const rowCanExpand = table.getCanSomeRowsExpand();

  return (
    <>
      {headerColumns.map((headerGroup) => (
        <StyledHeaderRow
          key={headerGroup.id}
          columnsSize={columnsSize}
          theme={theme}
          className={"table-header-row"}
        >
          {headerGroup.headers.map((header) => {
            return (
              <StyledCell
                key={header.id}
                onClick={header.column.getToggleSortingHandler()}
              >
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
                {header.column.getCanSort() && (
                  <SortButton isSorted={header.column.getIsSorted()} />
                )}
                {header.column.getCanFilter() && (
                  <ColumnFilterButton<TRow> column={header.column} />
                )}
              </StyledCell>
            );
          })}
          {rowCanExpand && (
            <StyledCell style={{ minWidth: "36px", boxSizing: "border-box" }} />
          )}
        </StyledHeaderRow>
      ))}
    </>
  );
};
